import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { Observable } from 'rxjs';
import {
  EtransportModifVehicleDtoModel,
  ETransportModifVehicleHistoryVoModel,
  EtransportModifVehicleMetadataModel,
} from '@well/delivery-libs/etransport/domain-model';

@Injectable({
  providedIn: 'root',
})
export class EtransportModifVehicleResourceService extends AbstractResourceService<
  EtransportModifVehicleDtoModel,
  EtransportModifVehicleDtoModel,
  EtransportModifVehicleMetadataModel,
  null
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('eTransportModifVehicleUrl'),
      EtransportModifVehicleDtoModel,
      EtransportModifVehicleDtoModel,
      EtransportModifVehicleMetadataModel,
      undefined
    );
  }

  getTemplateFromNotification(
    uit: string
  ): Observable<JsonApiResource<EtransportModifVehicleDtoModel, EtransportModifVehicleMetadataModel>> {
    return this.httpClient?.get(`${this.url}/template/notification/${uit}`).pipe(this.getDtoMapper());
  }

  getModifVehicleHistory(
    notificationUuid: string
  ): Observable<JsonApiResource<ETransportModifVehicleHistoryVoModel[], JsonApiListResourceMetadataBase>> {
    return this.httpClient?.get(`${this.url}/history/${notificationUuid}`).pipe(this.getDtoMapper());
  }
}
